import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IError } from "../../../../interfaces/base";
import { IFetchDashboardStatsState } from "../../../../interfaces/store/dashboard-interface";

const initialState: IFetchDashboardStatsState = {
  traineesCount: null,
  currentMonthRevenue: null,
  traineesCount30DaysAgo: null,
  totalRevenueSoFar: null,

  loading: false,
  error: null,
  requestState: "prepare",
  operation: null,
};

const _getDashboardStatsStart = (
  state: IFetchDashboardStatsState,
  { payload }: PayloadAction<any>
) => {
  state.loading = true;
  state.error = null;
  state.requestState = "start";
  state.operation = "read";
};

const _getDashboardStatsSuccess = (
  state: IFetchDashboardStatsState,
  { payload }: PayloadAction<any>
) => {
  state.traineesCount = payload.data.traineesCount;
  state.currentMonthRevenue = payload.data.currentMonthRevenue;
  state.traineesCount30DaysAgo = payload.data.traineesCount30DaysAgo;
  state.totalRevenueSoFar = payload.data.totalRevenueSoFar;

  state.loading = false;
  state.error = null;
  state.requestState = "finish";
};

const _getDashboardStatsFailed = (
  state: IFetchDashboardStatsState,
  { payload }: PayloadAction<IError>
) => {
  state.loading = false;
  state.error = payload;
  state.requestState = "error";
};

const _resetDashboard = (
  state: IFetchDashboardStatsState,
) => {
  return { ...initialState };
};

const DashboardStatsSlice = createSlice({
  name: "dashboardStats",
  initialState,
  reducers: {
    getDashboardStatsStart: _getDashboardStatsStart,
    getDashboardStatsSuccess: _getDashboardStatsSuccess,
    getDashboardStatsFailed: _getDashboardStatsFailed,
    resetDashboard: _resetDashboard,
  },
});

export const {
  getDashboardStatsStart,
  getDashboardStatsSuccess,
  getDashboardStatsFailed,
  resetDashboard,
} = DashboardStatsSlice.actions;
export default DashboardStatsSlice.reducer;
